/* =========================================================
   PA_DATA bootstrap — NO MORE MOCK DATA.
   The arrays below are initially empty; HydratedLegacyPage fills them
   with live backend data before the legacy pages render.
   Helper functions (photo/portrait placeholders) are kept because the
   legacy components call them; they generate picsum URLs on demand and
   contain no business data.
   ========================================================= */

window.PA_DATA = (function () {
  const photo = (seed, w = 1200, h = 800) => `https://picsum.photos/seed/pa-${seed}/${w}/${h}`;
  const portrait = (seed, w = 600, h = 750) => `https://picsum.photos/seed/pa-port-${seed}/${w}/${h}`;

  return {
    communes: [],
    disciplines: [],
    artists: [],
    venues: [],
    parcours: [],
    programSillons: [],
    photo,
    portrait,
  };
})();
